import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CurrencyModule } from '@app/directives';
import { ProjectV2 } from '@app/interfaces';
import { ToastrService } from 'ngx-toastr';
import { NgxSliderModule, Options } from '@angular-slider/ngx-slider'
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'mnf-section-simulator',
  standalone: true,
  imports: [NgxSliderModule, CommonModule, FormsModule, ReactiveFormsModule, CurrencyModule],
  templateUrl: './section-simulator.component.html',
  styleUrls: ['./section-simulator.component.scss'],
})
export class SectionSimulatorComponent implements OnInit {
  @Input() infoProject: ProjectV2;
  @Input() totalPerformance: number;
  @Input() customClass: string;
  @Input() amountFromURL: number;

  formCalculate: FormGroup;

  performanceEstimate: number
  repartsTotal: number;
  monthsMaxLimit: number;
  soldTotalPerformance: number;
  repartEstimate: number;
  totalSum: number = 0;
  updatingValue = false;

  stepOne: number;
  stepTwo: number;
  stepThree: number;
  stepFour: number;

  showInfoText: boolean = false;

  capital = [
    { capitalization: 'Mensual', text: 'Cada mes', 'value': 12 },
    { capitalization: 'Bimestral', text: 'Cada 2 meses', 'value': 6 },
    { capitalization: 'Venta o en 5 meses', text: 'Después de la venta o en 5 meses', value: 6 },
    { capitalization: 'Semestral', text: 'Cada 6 meses', value: 2 },
    { capitalization: 'Anual', text: 'Cada año', value: 1 },
    { capitalization: 'Semanal', text: 'Cada semana', value: 52 },
    { capitalization: 'Diario', text: 'Cada día', value: 365 },
    { capitalization: 'Quincenal', text: 'Cada 15 días', value: 24 },
    { capitalization: 'Trimestral', text: 'Cada 3 meses', value: 4 },
  ]

  options: Options = {
    floor: 1000, //lo puse en 1,000 ya que no podia disminuir el monto inicial y estaria obligado a invertir 10,000
    ceil: 1000000,
    showSelectionBar: true,
    step: 1000,
    translate: (value: number): string => {
      return "$" + value.toLocaleString('es-US', { minimumFractionDigits: 2 });
    }
  };

  get initAmount() {
    return this.formCalculate.controls.initAmount;
  }

  constructor(
    private fb: FormBuilder,
    private toastServ: ToastrService,
    private router: ActivatedRoute
  ) { 
    this.formCalculate = this.fb.group({
      initAmount: [10000, [Validators.max(this.infoProject?.participationsMaxPerUser * 1000)]],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.amountFromURL && changes.amountFromURL.currentValue) {
      this.initAmount.setValue(changes.amountFromURL.currentValue);
      this.editInput();
    }
  }

  ngOnInit(): void {
    if(this.infoProject?.monthsMaxLimit != null || this.infoProject?.monthsMaxLimit != undefined) {
      this.monthsMaxLimit = this.extractNumber(this.infoProject?.monthsMaxLimit.toString());
    } else {
      this.monthsMaxLimit = this.extractNumber(this.infoProject?.monthsEstimateResidential || this.infoProject?.monthsEstimateResidential);
    }

    if(this.infoProject?.state !== 'residential') {
      this.options.ceil = this.infoProject?.participationsMaxPerUser * 1000;
    } else {
      this.options.ceil = this.infoProject?.phase?.total * 1000;
    }

    if(this.infoProject?.state !== 'residential') {
      // Nuevos calculos para simulador
      this.stepOne = this.initAmount.value * (this.infoProject?.performance) / 1000;
      this.stepTwo = ((this.stepOne) * this.monthsMaxLimit / 12);
      this.stepThree = this.calculateTotalReparts(this.infoProject?.capitalization, this.monthsMaxLimit);
      this.stepFour = this.stepTwo / this.stepThree;
      this.infoProject?.soldPerformance ? this.soldTotalPerformance = (this.initAmount.value * (this.infoProject?.soldPerformance) / 100) * (this.extractNumber(this.infoProject?.monthsMaxLimit?.toString()) / 12) : 0;
      this.repartEstimate = this.initAmount.value * this.stepFour / 1000;
      this.totalPerformance = this.initAmount.value * this.stepTwo / 1000;      
      this.totalSum = this.initAmount.value + this.totalPerformance;
    } else {
      this.stepOne = (this.initAmount.value * 12 ) / 1000;
      this.stepTwo = ((this.stepOne) * 5 / 12);
      this.stepFour = this.stepTwo / 1;
      this.totalPerformance = this.initAmount.value * this.stepTwo / 1000;
      this.repartEstimate = this.initAmount.value * this.stepFour / 1000;
      this.totalSum = this.initAmount.value + this.totalPerformance;
    }
  }

  sumInit() {
    if(this.initAmount.value === this.infoProject?.phase?.total * 1000) {
      this.toastServ.info("El monto inicial no puede ser mayor al total de la fase");
    } else {
      this.initAmount.setValue(this.initAmount.value + 1000);
      this.editInput();
    }
  }

  lessInit() {
    if(this.initAmount.value === 0) {
      this.toastServ.info("El monto inicial no puede ser menor a 0");
    } else {
      this.initAmount.setValue(this.initAmount.value - 1000);
      this.editInput();
    }
  }

  editValue(value: number) {
    this.initAmount.setValue(value);
    this.editInput();
  }

  editInput() {
    if(this.infoProject?.state !== 'residential') {
      this.performanceEstimate = this.initAmount.value * this.totalPerformance / 100;
      this.repartEstimate = this.initAmount.value * this.stepFour / 1000;
      this.totalPerformance = this.initAmount.value * this.stepTwo / 1000;      
      this.totalSum = this.initAmount.value + this.totalPerformance;
      this.infoProject?.soldPerformance ? this.soldTotalPerformance = (this.initAmount.value * (this.infoProject?.soldPerformance) / 100) * (this.extractNumber(this.infoProject?.monthsMaxLimit.toString()) / 12) : 0;
    } else {
      this.totalPerformance = this.initAmount.value * this.stepTwo / 1000;
      this.performanceEstimate = (this.initAmount.value * 5) / 100;
      this.totalSum = this.initAmount.value + this.totalPerformance;      
    }
  }

  getTextByCapitalization(capitalization: string): string {
    const item = this.capital.find(item => item.capitalization === capitalization);
    return item ? item.text : '';
  }

  getValueByCapitalization(capitalization: string): number {
    const item = this.capital.find(item => item.capitalization === capitalization);
    return item ? item.value : 0;
  }

  extractNumber(text: string): number {
    const results = text?.match(/\d+/g);
    if (results && results?.length > 0) {
      return Math.max(...results.map(num => parseInt(num, 10)));
    }
    throw new Error("No se encontró ningún número en el texto.");
  }

  calculateTotalReparts(period: string, value: number): number {
    switch (period.toLowerCase()) {
      case 'mensual':
        return value;
      case 'bimestral':
        return value / 2;
      case 'trimestral':
        return value / 3;
      case 'semestral':
        return value / 6;
      case 'al final del plazo':
        return 1;
      case 'venta o en 5 meses':
        return 1;
      default:
        return 1;
    }
  }
  
  shareSimulator() {
    let urlActual: string = '';
    let location = window.location.href;
    this.router.queryParams.subscribe(params => {
      if (params) {
        if(params?.sim || params?.amount) {
          urlActual = window.location.href.split('?')[0]+'?sim=1'+'&amount=' + this.initAmount.value;
        } else {
          location.includes('?') ? urlActual = location +'&sim=1'+'&amount=' + this.initAmount.value : urlActual = location +'?sim=1'+'&amount=' + this.initAmount.value;
        }
      }
    });
    const el = document.createElement('textarea');
    el.value = urlActual;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    this.toastServ.success('¡Se ha copiado tu link de simulador al portapapeles!');    
  }

}
